import type {SocialAccount} from '@Components/social-media/account.vo';

export enum PreviewAvatarShape {
  CIRCLE = 'CIRCLE',
  ROUNDED_SQUARE = 'ROUNDED_SQUARE',
}

export interface PreviewAvatarProps {
  account: SocialAccount;
  className?: string;
  shape?: PreviewAvatarShape;
}
